'use client'

import { CollectionListingNoFilter } from '@/app/[locale]/collection/_components/collection-listing-no-filter'
import { CollectionContainer } from '@/components/common/collection/collection-container'
import { Tabs } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { CoolSetBanner } from './cool-set-banner'

interface FlashSaleProductsSliderProps {
  filterTabs?: { label: string; value: string }[]
  banner?: { desktop: string; mobile: string }
  className?: string
  triggerClassName?: string
  tabClassName?: string
  defaultTab?: string
}

export const CoolSetFilterProduct = ({
  filterTabs,
  banner,
  className,
  triggerClassName,
  tabClassName,
  defaultTab,
}: FlashSaleProductsSliderProps) => {
  const [currentSlug, setCurrentSlug] = useState<string>(defaultTab || '')

  const filter: { key: string; value: string }[] = [
    {
      key: 'limit',
      value: '12',
    },
    {
      key: 'sort',
      value: 'bestseller',
    },
  ]

  const onChangeTab = (value: string) => {
    setCurrentSlug(value)
  }

  return (
    <CollectionContainer className={cn('py-8', className)}>
      <CoolSetBanner
        desktop={banner?.desktop || ''}
        mobile={banner?.mobile || ''}
      />
      <div className='flex items-center justify-between'>
        <Tabs
          className={cn('my-4 p-0 lg:mt-6', tabClassName)}
          triggerClassName={cn(
            'text-sm leading-tight font-normal font-pangea px-4 py-2 lg:px-6 lg:py-3',
            triggerClassName
          )}
          variant='filter'
          options={filterTabs || []}
          defaultValue={defaultTab || ''}
          onChange={(value) => setCurrentSlug(value)}
        />
      </div>

      <CollectionListingNoFilter
        slug={currentSlug}
        filter={filter}
        isHideId={true}
      />
    </CollectionContainer>
  )
}
